/*!
 * dasoertliche-javascript-library-7.26
 * 
 * Copyright (C) 2008-2025 TENSQUARE GmbH. All rights reserved.
 * https://www.tensquare.de
 * Die Inhalte dieser Datei sind urheberrechtlich geschützt. Sie dürfen
 * weder ganz noch in Teilen vervielfältigt, verbreitet oder öffentlich
 * zugänglich gemacht werden. Jegliche Nutzung, sowohl zu privaten als
 * auch zu kommerziellen Zwecken, bedarf der schriftlichen Genehmigung
 * der TENSQUARE GmbH.
 */
if (!$oe$ || !$ || !$oe$.ui) {
    throw new Error("Core libs missing");
}

(function(global, win, document, undefined) {
    "use strict";
    var OE_SCROLLER_TYPE = {
        marktjagd_hitlist: 2,
        marktjagd_detail: 3,
        marktjagd_regio: 4,
        offer_detail: 8,
        printad_detail: 9,
        feature_banner: 10
    }, DATA_ATTRIBUTES = {
        src: "src",
        title: "title",
        prefix: "data-"
    }, namespace = global.getNamespace("media");
    function ScrollerHandler(data, scrollerType, config) {
        var self = this, $win = $(win), winEvents = "scroll resize", UNIQUE_SCROLLER_KEY = "scroller_" + global.util.Tools.getUniqueKey(), UNIQUE_KEY_SEPARATOR = "-", SELECTOR_PLACEHOLDER = "<<SCROLLERTYPECLASS>>", syncScrollerClass, options, defaultOptions = {
            lazyInit: true,
            selector: ".fredsel_box" + SELECTOR_PLACEHOLDER + " ul",
            tostart: ".fredsel_box" + SELECTOR_PLACEHOLDER + " .tostart",
            toend: ".fredsel_box" + SELECTOR_PLACEHOLDER + " .toend",
            next: ".fredsel_box" + SELECTOR_PLACEHOLDER + " .next",
            prev: ".fredsel_box" + SELECTOR_PLACEHOLDER + " .back",
            autoplay: false,
            circular: false,
            items: {
                start: 1,
                visible: 1
            },
            onclick: null,
            picselector: ".pic a",
            pic: "pic",
            flagit: "flagit",
            flagittitle: "Bild melden",
            placeholder: "img/inprogress.gif",
            fadeIn: 600,
            _isSyncScroller: false,
            activeclass: "active",
            enableOverlay: false,
            lbFooter: {
                img: {
                    src: "img/lgo_golocal_layer.png",
                    class: "thrdparty"
                }
            },
            onScrollInterval: 250
        }, defaultCarouselOptions = {
            items: {
                visible: 1,
                width: 138
            },
            responsive: true,
            width: "100%",
            circular: false,
            onCreate: function(data) {},
            scroll: {
                fx: "directscroll",
                items: "page",
                pauseOnHover: false,
                onBefore: function(data) {}
            },
            auto: false
        }, scrollerTypeCarouselOptions, container, carouselOptions, carousel, syncScrollerHandler, clickItem, items = [], itemEventListenerList = {}, didScroll = false, intervalId;
        function init() {
            var visibleCount, circular = false, scrollerTypeClass, syncScrollerVisibleCount = 1, scrollItemCount = defaultCarouselOptions.scroll.items, autoScroll = false;
            if (!scrollerTypeExists()) {
                global.log('Unsupported SCROLLERTYPE: "' + scrollerType + '". Available: ', OE_SCROLLER_TYPE);
                return;
            }
            switch (scrollerType) {
              case OE_SCROLLER_TYPE.marktjagd_detail:
                scrollerTypeClass = "scr03";
                visibleCount = 5;
                break;

              case OE_SCROLLER_TYPE.marktjagd_hitlist:
                scrollerTypeClass = "scr02";
                visibleCount = 1;
                break;

              case OE_SCROLLER_TYPE.marktjagd_regio:
                scrollerTypeClass = "scr01";
                visibleCount = 4;
                break;

              case OE_SCROLLER_TYPE.offer_detail:
                scrollerTypeClass = config && config._isSyncScroller ? "scr11" : "scr12";
                syncScrollerClass = "scr11";
                visibleCount = 5;
                scrollItemCount = 1;
                break;

              case OE_SCROLLER_TYPE.printad_detail:
                scrollerTypeClass = config && config._isSyncScroller ? "scr13" : "scr14";
                syncScrollerClass = "scr13";
                visibleCount = 5;
                scrollItemCount = 1;
                break;

              case OE_SCROLLER_TYPE.feature_banner:
                scrollerTypeClass = config && config._isSyncScroller ? "scr15" : "scr16";
                syncScrollerClass = undefined;
                visibleCount = 1;
                scrollItemCount = 1;
                autoScroll = true;
                break;
            }
            circular = data.length > visibleCount;
            setOptions(scrollerTypeClass);
            container = $(options.selector);
            if (container.length === 0) {
                global.trace("ScrollerHandler: No parent element found for selector: " + options.selector);
                return;
            }
            scrollerTypeCarouselOptions = {
                items: {
                    visible: visibleCount
                },
                auto: autoScroll,
                circular: circular,
                onCreate: function(data) {
                    loadImages(data.items);
                },
                scroll: {
                    items: scrollItemCount,
                    onBefore: function(data) {
                        loadImages(data.items.old.prev());
                        loadImages(data.items.visible);
                    }
                },
                prev: {
                    button: options.prev
                },
                next: {
                    button: options.next
                }
            };
            carouselOptions = $.extend(true, {}, defaultCarouselOptions, scrollerTypeCarouselOptions);
            if (options._isSyncScroller) {
                carouselOptions.items.visible = syncScrollerVisibleCount;
            }
            container = $(container.get(0));
            if (options.lazyInit && !inViewport()) {
                $win.on(winEvents, self.onWindowScroll);
                intervalId = setInterval(self.checkInVieport, options.interval);
            } else {
                finalInit();
            }
        }
        function finalInit() {
            var overlayHandler;
            initItems();
            carousel = container.carouFredSel(carouselOptions);
            doPostProcessing();
            if (global.val.isDefined(syncScrollerClass) && !options._isSyncScroller) {
                syncScrollerHandler = new ScrollerHandler(data, scrollerType, {
                    _isSyncScroller: true,
                    lazyInit: false
                });
                syncScrollerHandler.getCarousel().trigger("configuration", [ "synchronise", [ getSelector(), false ] ]);
            }
            if (options.enableOverlay && scrollerType === OE_SCROLLER_TYPE.marktjagd_regio) {
                overlayHandler = new global.media.OverlayHandler(self, {
                    onclick: options.onclick,
                    loadimg: options.placeholder
                });
            }
        }
        function setOptions(scrollerClass) {
            var tmpOptions = $.extend(true, {}, defaultOptions);
            tmpOptions.selector = tmpOptions.selector.replace(SELECTOR_PLACEHOLDER, "." + scrollerClass);
            tmpOptions.tostart = tmpOptions.tostart.replace(SELECTOR_PLACEHOLDER, "." + scrollerClass);
            tmpOptions.toend = tmpOptions.toend.replace(SELECTOR_PLACEHOLDER, "." + scrollerClass);
            tmpOptions.next = tmpOptions.next.replace(SELECTOR_PLACEHOLDER, "." + scrollerClass);
            tmpOptions.prev = tmpOptions.prev.replace(SELECTOR_PLACEHOLDER, "." + scrollerClass);
            options = $.extend(true, {}, tmpOptions, config || {});
        }
        function doPostProcessing() {
            bindItemEventListeners();
            initLightbox();
        }
        function initLightbox() {
            var lightbox, handler;
            switch (scrollerType) {
              case OE_SCROLLER_TYPE.marktjagd_detail:
                handler = onShowMarktjagdDetailLightbox;
                break;

              case OE_SCROLLER_TYPE.marktjagd_hitlist:
                handler = onShowMarktjagdHitlistLightbox;
                break;

              case OE_SCROLLER_TYPE.marktjagd_regio:
                break;

              case OE_SCROLLER_TYPE.offer_detail:
                if (options._isSyncScroller) {
                    handler = onShowOfferLightbox;
                }
                break;

              case OE_SCROLLER_TYPE.printad_detail:
                if (options._isSyncScroller) {
                    handler = onShowPrintAdLightbox;
                }
                break;

              default:
                break;
            }
            if (!handler) {
                return;
            }
            lightbox = new global.media.LightboxHandler(options.selector + " " + options.picselector, {
                onNext: handler.getBinding(self),
                onPrev: handler.getBinding(self),
                beforeShowLightbox: function() {
                    clickItem = [ $(this)[0].$el ];
                },
                afterShowLightbox: function() {
                    handler(clickItem);
                }
            });
        }
        function onShowOfferLightbox(element) {
            slideTo(element);
        }
        function onShowMarktjagdDetailLightbox(element) {
            slideTo(element);
        }
        function onShowMarktjagdHitlistLightbox(element) {
            slideTo(element);
        }
        function onShowPrintAdLightbox(element) {
            slideTo(element);
        }
        function slideTo(element) {
            element = element[0];
            carousel.trigger("slideTo", element.closest("li"));
        }
        function getItemIdx(id) {
            var idArr = id.split(UNIQUE_KEY_SEPARATOR);
            if (idArr.length === 3) {
                return Number(idArr[idArr.length - 1]);
            }
        }
        function getItemData(id) {
            var idx;
            if (global.val.isNumber(id)) {
                idx = id;
            } else if (global.val.isString(id) && id.indexOf(UNIQUE_SCROLLER_KEY) !== -1) {
                idx = getItemIdx(id);
            }
            if (data.length > idx) {
                return data[idx];
            }
        }
        function initItems() {
            addScrollerItems(initStaticItems());
        }
        function initStaticItems() {
            var staticItemCount = 0;
            if (scrollerType === OE_SCROLLER_TYPE.feature_banner) {
                container.find("div").each(function(idx, item) {});
            } else {
                container.find("li").each(function(idx, item) {
                    var $item = $(item), itemData = getItemData(idx), id = getUniqueId(idx), imgAttr = {
                        id: id
                    }, img;
                    imgAttr["data-lightbox-gallery"] = UNIQUE_SCROLLER_KEY;
                    if (scrollerType === OE_SCROLLER_TYPE.marktjagd_regio && (global.val.isUndefined(itemData) || global.val.isUndefined(itemData.url) || global.val.isUndefined(itemData.img))) {
                        return;
                    }
                    switch (scrollerType) {
                      case OE_SCROLLER_TYPE.marktjagd_detail:
                      case OE_SCROLLER_TYPE.marktjagd_hitlist:
                      case OE_SCROLLER_TYPE.offer_detail:
                      case OE_SCROLLER_TYPE.printad_detail:
                        imgAttr.href = itemData.img.src;
                        $item.find(options.picselector).attr(imgAttr);
                        break;

                      case OE_SCROLLER_TYPE.marktjagd_regio:
                        img = $item.find(options.picselector);
                        img.attr(getUrlAttributes(itemData.url, {
                            id: id
                        }));
                        break;
                    }
                    items.push($item);
                    staticItemCount++;
                });
            }
            return staticItemCount;
        }
        function addScrollerItems(staticItemCount) {
            var itemData, $item;
            for (var i = staticItemCount; i < data.length; i++) {
                itemData = data[i];
                $item = createItem(itemData, i);
                container.append($item);
                items.push($item);
            }
        }
        function createItem(itemData, key) {
            var $item, id = getUniqueId(key), imgAttr = {
                src: options.placeholder
            }, ankerTagAttr = {
                id: id,
                href: "#"
            }, imageTitle = "";
            ankerTagAttr["data-lightbox-gallery"] = UNIQUE_SCROLLER_KEY;
            if (itemData.img) {
                if (itemData.img.src) {
                    if (scrollerType === OE_SCROLLER_TYPE.marktjagd_regio) {
                        ankerTagAttr = $.extend(true, ankerTagAttr, getUrlAttributes(itemData.url));
                    } else {
                        ankerTagAttr.href = itemData.img.src;
                    }
                }
            }
            if (itemData.title) {
                ankerTagAttr.title = itemData.title;
            }
            if (global.val.isDefined(itemData.img)) {
                if (global.val.isDefined(itemData.img.title)) {
                    imageTitle = itemData.img.title;
                    imgAttr[DATA_ATTRIBUTES.prefix + DATA_ATTRIBUTES.src] = imageTitle;
                    imgAttr[DATA_ATTRIBUTES.prefix + DATA_ATTRIBUTES.title] = imageTitle;
                }
            }
            switch (scrollerType) {
              case OE_SCROLLER_TYPE.marktjagd_hitlist:
                imgAttr[DATA_ATTRIBUTES.prefix + DATA_ATTRIBUTES.src] = itemData.img.thumb;
                $item = $("<li>").append($("<div>").attr("class", options.pic).append($("<a>").attr(ankerTagAttr).append($("<img>").attr(imgAttr)))).append($("<div>").attr("class", "title").html(itemData.title)).append($("<div>").attr("class", "name").html(itemData.subtitle)).append($("<span>").html(itemData.subline));
                break;

              case OE_SCROLLER_TYPE.marktjagd_detail:
                imgAttr[DATA_ATTRIBUTES.prefix + DATA_ATTRIBUTES.src] = itemData.img.thumb;
                $item = $("<li>").append($("<div>").attr("class", options.pic).append($("<a>").attr(ankerTagAttr).append($("<img>").attr(imgAttr)))).append($("<div>").attr("class", "name").html(itemData.subtitle)).append($("<div>").attr("class", "title").html(itemData.title)).append($("<span>").html(itemData.subline));
                break;

              case OE_SCROLLER_TYPE.marktjagd_regio:
                imgAttr[DATA_ATTRIBUTES.prefix + DATA_ATTRIBUTES.src] = itemData.img.thumb;
                $item = $("<li>").append($("<div>").attr("class", options.pic).append($("<a>").attr(ankerTagAttr).append($("<img>").attr(imgAttr))));
                break;

              case OE_SCROLLER_TYPE.offer_detail:
              case OE_SCROLLER_TYPE.printad_detail:
                imgAttr[DATA_ATTRIBUTES.prefix + DATA_ATTRIBUTES.src] = itemData.img.src;
                $item = $("<li>").append($("<div>").attr({
                    class: options.pic
                }).append($("<img>").attr(imgAttr)));
                if (options._isSyncScroller) {
                    $item.find("img").wrap($("<a>").attr(ankerTagAttr));
                }
                break;
            }
            return $item;
        }
        function getUrlAttributes(urlData, addAttr) {
            var attr = addAttr || {};
            if (urlData.hasOwnProperty("href")) {
                attr.href = urlData.href;
            }
            if (urlData.hasOwnProperty("target") && urlData.target.length > 0) {
                attr.target = urlData.target;
            }
            return attr;
        }
        function bindItemEventListeners() {
            var $item;
            for (var i in items) {
                if (!items.hasOwnProperty(i)) {
                    continue;
                }
                $item = items[i];
                $item.off();
                $item.on("click", function(event) {
                    clickItem = [ $(this).find(options.picselector) ];
                    self.onClick(event);
                }).trigger("mouseenter");
                addInternalEventListener($item, i);
                addExternalItemEventListener($item, i);
            }
        }
        function addExternalItemEventListener(item, pos) {
            var listener;
            for (var event in itemEventListenerList) {
                if (itemEventListenerList.hasOwnProperty(event)) {
                    listener = itemEventListenerList[event];
                    for (var i = 0; i < listener.length; i++) {
                        item.on(event, listener[i]);
                    }
                }
            }
        }
        function setActiveClass(element) {
            var $item;
            for (var i in items) {
                $item = items[i];
                $item.removeClass(options.activeclass);
            }
            element.addClass(options.activeclass);
        }
        function addInternalEventListener(item, pos) {
            var intPos = parseInt(pos, 10);
            switch (scrollerType) {
              case OE_SCROLLER_TYPE.offer_detail:
              case OE_SCROLLER_TYPE.printad_detail:
                if (!options._isSyncScroller) {
                    item.on("click", function(event) {
                        setActiveClass($(this));
                        syncScrollerHandler.getCarousel().trigger("slideTo", intPos);
                    });
                }
                break;
            }
        }
        function addItemEventListener(event, listener) {
            var $item;
            if (items.length === 0) {
                if (!global.val.isArray(itemEventListenerList[event])) {
                    itemEventListenerList[event] = [];
                }
                itemEventListenerList[event].push(listener);
            } else {
                for (var i in items) {
                    $item = items[i];
                    $item.on(event, listener);
                }
            }
        }
        function scrollerTypeExists() {
            for (var i in OE_SCROLLER_TYPE) {
                if (OE_SCROLLER_TYPE[i] === scrollerType) {
                    return true;
                }
            }
            return false;
        }
        function onClick(event) {
            if (global.val.isFunction(options.onclick)) {
                options.onclick(event);
            }
        }
        function autoPlay(play) {
            if (play === false) {
                carousel.trigger("stop");
            } else {
                carousel.trigger("play");
            }
        }
        function loadImages(items) {
            if (!items.length) {
                return;
            }
            $.each(items, function(key, val) {
                var item = $(val), parent, origSrc, title;
                if (!item.is("img")) {
                    item = item.find("img");
                }
                if (item.is("img")) {
                    if (item.attr("src").indexOf(options.placeholder) !== -1) {
                        origSrc = item.data(DATA_ATTRIBUTES.src);
                        title = item.data(DATA_ATTRIBUTES.title);
                        parent = item.parent();
                        parent.append($("<img>").attr({
                            src: origSrc,
                            title: title
                        }));
                        item.remove();
                    }
                }
            });
        }
        function getCarousel() {
            return carousel;
        }
        function getSelector() {
            return options.selector;
        }
        function syncronise(selector) {
            carousel.trigger("configuration", [ "synchronise", [ selector, false ] ]);
        }
        function getUniqueId(idx) {
            idx = global.val.isDefined(idx) && idx !== null ? idx : global.util.Tools.getUniqueKey();
            return UNIQUE_SCROLLER_KEY + UNIQUE_KEY_SEPARATOR + scrollerType + UNIQUE_KEY_SEPARATOR + idx;
        }
        this.onWindowScroll = function() {
            didScroll = true;
        };
        this.checkInVieport = function() {
            if (!didScroll) {
                return;
            }
            didScroll = false;
            if (inViewport()) {
                $win.off(winEvents, self.onWindowScroll);
                clearInterval(intervalId);
                self.finalInit();
            }
        };
        function inViewport() {
            var viewportBottom = $win.scrollTop() + $win.height(), syncInViewport = false;
            if (global.val.isString(syncScrollerClass)) {
                syncInViewport = viewportBottom >= $("." + syncScrollerClass).offset().top;
            }
            return viewportBottom >= container.offset().top || syncInViewport;
        }
        this.onClick = onClick;
        this.autoPlay = autoPlay;
        this.getCarousel = getCarousel;
        this.getSelector = getSelector;
        this.getItemData = getItemData;
        this.syncronise = syncronise;
        this.finalInit = finalInit;
        this.addItemEventListener = addItemEventListener;
        init();
    }
    namespace.ScrollerHandler = ScrollerHandler;
    namespace.SCROLLERTYPE = OE_SCROLLER_TYPE;
    function ScrollerOverlay(scrollerItem, data, scrollerType, options) {
        var self = this, defaultData = {
            moretext: "mehr..."
        }, defaultOptions = {
            loadimg: "",
            container: ".item.double",
            cssclass: "mj_preview",
            imgid: "call4overlay_",
            loadimgid: "call4overlay_l_",
            divid: "call4overlay_p_",
            zindex: 500,
            fadein: 10,
            onclick: null
        };
        this.parent = scrollerItem;
        this.data = $.extend(true, {}, defaultData, data || {});
        this.scrollerType = global.val.isDefined(scrollerType) ? scrollerType : global.media.type.marktjagd_regio;
        this.options = $.extend(true, {}, defaultOptions, options || {});
        this.overlay = null;
        captureExternalEvents();
        function onClick(event) {
            if (global.val.isFunction(self.options.onclick)) {
                self.options.onclick.call(self, event, self.data);
            }
        }
        function removeAll() {
            $("." + self.options.cssclass).each(function(evt) {
                $(this).remove();
            });
        }
        function captureExternalEvents() {
            $(document).on("click mouseup touchstart", function(event) {
                if ($(event.target).parents("a." + self.options.cssclass).length === 0) {
                    self.removeAll();
                }
            });
        }
        function show() {
            self.removeAll();
            switch (self.scrollerType) {
              case global.media.SCROLLERTYPE.marktjagd_regio:
                showMarktjagdRegio();
                break;

              default:
                global.log("Unsupported Scroller-Type: " + self.scrollerType);
            }
        }
        function showMarktjagdRegio() {
            var imgId = self.options.imgid + getRandomStr(), loadImageId = self.options.loadimgid + getRandomStr(), divId = self.options.divid + getRandomStr(), loadError = false, firstClickTriggered = false, $container;
            self.overlay = $("<a>").attr({
                class: self.options.cssclass,
                href: "#"
            }).css({
                "z-index": self.options.zindex
            }).on({
                "click touchstart": function(event) {
                    if (isTouchEventSupported()) {
                        if (win.navigator.msMaxTouchPoints) {
                            if (!firstClickTriggered) {
                                firstClickTriggered = true;
                                return false;
                            }
                            self.onClick(event);
                        } else {
                            self.onClick(event);
                        }
                    } else {
                        self.onClick(event);
                    }
                    return false;
                },
                mouseleave: function(event) {
                    self.remove();
                }
            }).append($("<p>").html(self.data.title).attr({
                title: self.data.title
            })).append($("<div>").attr({
                id: divId
            }).append($("<img>").attr({
                src: self.options.loadimg,
                id: loadImageId,
                alt: self.data.title,
                title: self.data.title
            }))).append($("<span>").html(self.data.moretext).attr({
                title: self.data.moretext
            }));
            $container = $(self.options.container);
            $container.append(self.overlay.fadeIn(self.options.fadein));
            setPosition();
            $("<img>").attr({
                src: self.data.img.src || $(self.parent).find("img").prop("src"),
                id: imgId,
                alt: self.data.title,
                title: self.data.title
            }).on({
                load: function(event) {
                    $("#" + loadImageId).remove();
                    $("#" + divId).append($(this).css({
                        width: "auto",
                        height: "auto"
                    }));
                },
                error: function(event) {
                    if (loadError === false) {
                        loadError = true;
                        $(this).attr("src", self.data.img.thumb);
                    }
                }
            }).each(function() {
                if (this.complete) {
                    $(this).trigger("load");
                }
            });
        }
        function getRandomStr() {
            return Math.floor((1 + Math.random()) * new Date().getTime()).toString(16);
        }
        function setPosition() {
            var xPos, yPos, parent;
            parent = $(self.parent);
            xPos = parent.offset().left + parent.width() / 2 - self.overlay.width() / 2;
            yPos = parent.offset().top + parent.height() / 2 - self.overlay.height() / 2;
            self.overlay.offset({
                left: xPos,
                top: yPos
            });
        }
        function remove() {
            $(self.overlay).remove();
        }
        function isTouchEventSupported() {
            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Touch/i.test(win.navigator.userAgent) || "ontouchstart" in document.documentElement && "ontouchend" in document.documentElement && "ontouchmove" in document.documentElement || "onmsgesturechange" in win) {
                return true;
            }
            return false;
        }
        this.onClick = onClick;
        this.removeAll = removeAll;
        this.remove = remove;
        this.show = show;
    }
    function ScrollerOverlayHandler(scrollerHandler, options) {
        var defaultOptions = {
            loadimg: "img/inprogress.gif"
        }, config, overlay;
        init();
        function onMouseEnter(event) {
            var scrollerItem = $(event.currentTarget), data = scrollerHandler.getItemData(scrollerItem.find("a").prop("id"));
            overlay = new global.media.Overlay(event.currentTarget, data, namespace.SCROLLERTYPE.marktjagd_regio, config);
            overlay.show();
            return false;
        }
        function init() {
            config = $.extend(true, {}, defaultOptions, options || {});
            scrollerHandler.addItemEventListener("touchstart mouseenter", onMouseEnter);
        }
    }
    namespace.Overlay = ScrollerOverlay;
    namespace.OverlayHandler = ScrollerOverlayHandler;
})($oe$, this, document);